import AreaContainer from "../AreaContainer";
import styles from './misrepesentaion.module.css';
import globalStyles from '../result.module.css';

const Misrepresentation = () => {

    return <AreaContainer area="misrep"  style={null} extraClass={null}>
        <div className={styles.MisWrapper}>
            <h2 className={globalStyles.subTitleText}>Misrepresentation Notice</h2>
            <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} >All the above information and descriptions (whether in the text, plans or photographs) are given in good faith but should not be relied upon as being a statement of representation or fact. Any areas, measurements or distances referred to are approximate only.</p>
            <p  className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`}>All data ©{(new Date().getFullYear())} Completely Property Technology Limited</p>
        </div>
                    
                
            </AreaContainer>
};

export default Misrepresentation;